import { msg } from 'gt-react';
import { createRoute } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { StackIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requirePermission,
} from '../route';
import { NamespacesPage } from './NamespacesPage';

/**
 * `/namespaces` — read-only list of the org's namespaces (`core_namespaces`),
 * each linking to its inventory at `/namespaces/$namespaceId`. Gated on
 * Namespace.Read so task readers don't see this admin inventory in the
 * Organization nav; listing for task pickers still uses Task.Read.
 */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/namespaces',
  staticData: {
    app: {
      nav: {
        label: msg('Namespaces', {
          context: 'sidebar nav label, Organization section',
        }),
        icon: <StackIcon className="h-4 w-4" weight="fill" />,
        group: 'Organization',
        order: 30,
      },
      access: {
        permissionsAnyOf: [{ action: Action.Read, subject: Subject.Namespace }],
      },
    },
  },
  component: NamespacesPage,
  loader: () => ({
    crumb: msg('Namespaces', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.Namespace,
    });
  },
});
